import { IconButton } from '@mui/material';

import { Icons, Select, Stack } from '@cast/design-system';

type DropdownFieldProps = {
  options: unknown[];
  value: unknown;
  onChange: (value: unknown) => void;
  onClear: () => void;
};

export const DropdownField = ({
  options,
  value,
  onChange,
  onClear,
}: DropdownFieldProps) => {
  const stringOptions = options.map(String);
  const selectedValue =
    value !== undefined ? String(value) : (undefined as unknown as string);

  return (
    <Stack direction="row" alignItems="center" gap={4}>
      <Select
        value={selectedValue}
        onChange={(selected) => {
          const index = stringOptions.indexOf(selected);
          if (index >= 0) {
            onChange(options[index]);
          }
        }}
        options={stringOptions}
        size="sm"
        inputProps={{ sx: { minWidth: 100 } }}
      />
      <IconButton size="small" onClick={onClear} disabled={value === undefined}>
        <Icons.MinusCircle size={16} />
      </IconButton>
    </Stack>
  );
};
